import axios from "axios"
import {API_URL} from "../data/Configuration"

/**
 * Authentication service
 * @author dame.gjorgjievski
 **/
const AuthService = {
    ENDPOINT : API_URL + "auth/",
    accessCode: async function(username, password) {
        return await axios.post(this.ENDPOINT + "code", {username: username, password: password})
    },
    authenticate: async function(username, password, code) {
        return await axios.post(this.ENDPOINT + "authenticate", {username: username, password: password, code: code})
    },
    authenticateFA: async function() {
        return axios.get(this.ENDPOINT + "authenticate")
    },
    register: async function(email, name, surname, password, phone) {
        return await axios.post(this.ENDPOINT + "register", {name: name, surname: surname, email: email, password: password, phone: phone})
    },
    resetPassword: async function(email) {
        return await axios.post(this.ENDPOINT + "password/reset?email="+ email)
    },
    logout: function() {
        sessionStorage.clear()
        localStorage.clear();
    },
    user: function(user) {
        if(user) {
            localStorage.setItem("user", JSON.stringify(user))
            return user;
        } else {
            return JSON.parse(localStorage.getItem('user'))
        }
    }
}

export default AuthService